import { render, staticRenderFns } from "./VendorSkeleton.vue?vue&type=template&id=75dc6f80"
import script from "./VendorSkeleton.vue?vue&type=script&lang=js"
export * from "./VendorSkeleton.vue?vue&type=script&lang=js"
import style0 from "./VendorSkeleton.vue?vue&type=style&index=0&id=75dc6f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports